/**
 * Narrows an unknown caught value to an `Error`, returning `undefined` when it
 * is not one.
 *
 * Use as the third argument to `appLogger.error(message, context, toError(err))`
 * so non-Error throwables (a rejected string, a GraphQL error object, a thrown
 * number, etc.) don't surface as empty `error.message` / `error.stack` fields in
 * the observability platform. Replaces the repeated
 * `error instanceof Error ? error : undefined` guard that proliferated across MFE
 * catch blocks.
 *
 * @param value The caught throwable; may or may not be an `Error`.
 * @returns The value typed as `Error`, or `undefined` when it is not an `Error`.
 */
export function toError(value: unknown): Error | undefined {
    return value instanceof Error ? value : undefined;
}
